import React from "react";
import { useSelector } from "react-redux";
import formateNumber from "../formateNumber";

export default function TotalPrice() {
  const cart = useSelector((state) => state.cart);
  const totalPrice = cart.reduce(
    (currentValue, element) => currentValue + element.price * element.quantity,
    0
  );
  return (
    <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
      <div className="flex justify-center items-center text-center">
        <div className="text-xl font-semibold">
          <p>Total Price</p>
          <p className="text-5xl">{formateNumber(totalPrice)}</p>
        </div>
      </div>
    </div>
  );
}
